module.exports = __webpack_public_path__ + "img/SVN.11abd191.svg";